export type SoundName = "correct" | "wrong" | "lessonComplete" | "levelUp" | "xpTick";

export interface SoundSpec {
    src: string;
    /** Per-sound gain under the player's master gain. */
    gain: number;
    /** Stops every other sound when it starts (celebrations). */
    exclusive?: boolean;
}

// correct, wrong, lesson-complete and level-up come from the "PN UI Sounds - Free Sampler" pack by
// PN Scripts (see public/sounds/CREDITS.md); xp-tick is generated by scripts/sounds/generate.mjs.
export const SOUND_FILES: Record<SoundName, SoundSpec> = {
    correct: { src: "/sounds/correct.mp3", gain: 0.45 },
    wrong: { src: "/sounds/wrong.mp3", gain: 0.35 },
    lessonComplete: { src: "/sounds/lesson-complete.mp3", gain: 0.55, exclusive: true },
    levelUp: { src: "/sounds/level-up.mp3", gain: 0.6, exclusive: true },
    xpTick: { src: "/sounds/xp-tick.mp3", gain: 0.25 }
};

export const SOUND_NAMES = Object.keys(SOUND_FILES) as SoundName[];
